import { createSlice } from "@reduxjs/toolkit";

const helpServiceSlice = createSlice({
  name: "helpService",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchHelpServices: (state) => {
      state.loading = true;
    },
    fetchHelpServicesSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchHelpServicesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchHelpServices,
  fetchHelpServicesSuccess,
  fetchHelpServicesFailure,
} = helpServiceSlice.actions;

export default helpServiceSlice.reducer;
